import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-268948c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "prefix" }
const _hoisted_2 = { class: "input-wrap" }
const _hoisted_3 = ["disabled", "placeholder"]
const _hoisted_4 = { class: "handlers" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "currentColor",
  width: "1em",
  height: "1em",
  viewBox: "64 64 896 896"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "currentColor",
  width: "1em",
  height: "1em",
  viewBox: "64 64 896 896"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "suffix" }

import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberInput',
  props: {
    value: {},
    disabled: { type: Boolean, default: false },
    placeholder: { default: '' },
    min: { default: 0 },
    max: { default: Infinity },
    step: { default: 1 }
  },
  emits: ["update:value", "input", "change", "blur", "focus", "enter"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const number = ref(0)
const focused = ref(false)

watch(() => props.value, () => {
  if (props.value !== number.value) {
    number.value = props.value
  }
}, {
  immediate: true,
})

watch(number, () => {
  let value = +number.value
  if (isNaN(value)) value = props.min
  else if (value > props.max) value = props.max
  else if (value < props.min) value = props.min

  number.value = value
  emit('update:value', number.value)
})

const handleBlur = (e: Event) => {
  focused.value = false
  emit('blur', e)
}
const handleFocus = (e: Event) => {
  focused.value = true
  emit('focus', e)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["number-input", {
      'disabled': _ctx.disabled,
      'focused': focused.value,
    }])
  }, [
    _createElementVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "prefix")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        disabled: _ctx.disabled,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((number).value = $event)),
        placeholder: _ctx.placeholder,
        onInput: _cache[1] || (_cache[1] = $event => emit('input', $event)),
        onFocus: _cache[2] || (_cache[2] = $event => handleFocus($event)),
        onBlur: _cache[3] || (_cache[3] = $event => handleBlur($event)),
        onChange: _cache[4] || (_cache[4] = $event => emit('change', $event)),
        onKeydown: _cache[5] || (_cache[5] = _withKeys($event => emit('enter', $event), ["enter"]))
      }, null, 40, _hoisted_3), [
        [_vModelText, number.value]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: "handler",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (number.value += _ctx.step))
        }, _hoisted_6),
        _createElementVNode("span", {
          class: "handler",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (number.value -= _ctx.step))
        }, _hoisted_8)
      ])
    ]),
    _createElementVNode("span", _hoisted_9, [
      _renderSlot(_ctx.$slots, "suffix")
    ])
  ], 2))
}
}

})